import { useCallback, useEffect, useState } from 'react';
import { describeError, type FriendlyError } from '@london-life/errors';

// one loading/error pattern for every admin page; failures become plain messages from the shared catalogue
export function useRequest<T>(load: () => Promise<T>) {
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<FriendlyError | null>(null);
  const [busy, setBusy] = useState(false);
  const run = useCallback(async () => {
    setBusy(true);
    setError(null);
    try {
      setData(await load());
    } catch (problem) {
      setError(describeError(problem));
    } finally {
      setBusy(false);
    }
  }, [load]);
  useEffect(() => {
    void run();
  }, [run]);
  // a page action failed (create, update): show it the same way as a failed load
  const fail = useCallback((problem: unknown) => setError(describeError(problem)), []);
  return { data, error, busy, reload: run, fail };
}
